import { z } from 'zod';

import { apiClient } from './client';

// Зеркалят backend App\Enums\MaintenancePriority / MaintenanceStatus. Раньше тут
// был выдуманный словарь (medium/new/acknowledged/resolved) -> любой реальный
// запрос ронял Zod-парсинг всего списка обслуживания.
export const MaintenancePriorityZ = z.enum(['low', 'normal', 'high', 'urgent']);
export const MaintenanceCategoryZ = z.enum([
  'plumbing',
  'electricity',
  'appliance',
  'heating',
  'window',
  'door',
  'internet',
  'other',
]);
export type MaintenanceCategory = z.infer<typeof MaintenanceCategoryZ>;
export const MaintenanceStatusZ = z.enum([
  'submitted',
  'accepted',
  'in_progress',
  'completed',
  'rejected',
  'cancelled',
]);

export const MaintenanceRequestZ = z.object({
  id: z.number().int(),
  lease_id: z.number().int(),
  title: z.string(),
  // backend description nullable -> z.string() ронял весь list-parse на пустом.
  description: z.string().nullable().optional(),
  priority: MaintenancePriorityZ,
  status: MaintenanceStatusZ,
  // backend шлёт photo_paths (строки), не объекты photos -> толерантная схема.
  photos: z.array(z.unknown()).default([]),
  created_at: z.string(),
  updated_at: z.string().optional(),
});
export type MaintenanceRequest = z.infer<typeof MaintenanceRequestZ>;

const ListZ = z.object({ data: z.array(MaintenanceRequestZ) });
const OneZ = z.object({ data: MaintenanceRequestZ });

export async function listMaintenance(params: { lease_id?: number } = {}): Promise<MaintenanceRequest[]> {
  const res = await apiClient.get('/maintenance', { params });
  return ListZ.parse(res.data).data;
}

// backend ждёт JSON { lease_id, category, title, description?, priority?,
// photo_paths[] } -- НЕ multipart. category обязателен (раньше форма его не
// слала -> 422), фото грузятся через /uploads/temp в photo_paths.
export interface CreateMaintenancePayload {
  lease_id: number;
  category: MaintenanceCategory;
  title: string;
  description?: string;
  priority?: z.infer<typeof MaintenancePriorityZ>;
  photo_paths?: string[];
}

export async function createMaintenance(
  payload: CreateMaintenancePayload,
): Promise<MaintenanceRequest> {
  const res = await apiClient.post('/maintenance', payload);
  return OneZ.parse(res.data).data;
}

export const maintenanceApi = { list: listMaintenance, create: createMaintenance };
